module.exports = __webpack_public_path__ + "static/media/manifesto.2c0f9e0d.md";